import { render, staticRenderFns } from "./socialShareBlock.vue?vue&type=template&id=33918bfe&scoped=true"
import script from "./socialShareBlock.vue?vue&type=script&lang=js"
export * from "./socialShareBlock.vue?vue&type=script&lang=js"
import style0 from "./socialShareBlock.vue?vue&type=style&index=0&id=33918bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33918bfe",
  null
  
)

export default component.exports